import React, { useEffect, useState } from 'react';
import EvidenceLightbox from './EvidenceLightbox';
import PurchaseModal from './PurchaseModal';
import { PurchaseError } from './PurchaseSummary';
import service from '../../services/manualPurchaseService';

const EvidenceViewer = ({ evidenceId, open, onClose }) => {
  const [access, setAccess] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(0);
  useEffect(() => {
    let active = true;
    let timer;
    setAccess(null);
    setError(null);
    if (!open || !evidenceId) return undefined;
    setLoading(true);
    service
      .getEvidence(evidenceId)
      .then(result => {
        if (!active) return;
        const lifetime = Date.parse(result.expiresAt) - Date.now();
        if (lifetime <= 0)
          throw new Error(
            'The image link has expired. Reload the image to request a new link.'
          );
        setAccess(result);
        timer = setTimeout(() => {
          setAccess(null);
          setRefresh(value => value + 1);
        }, Math.min(lifetime, 2147483647));
      })
      .catch(err => {
        if (active) setError(err);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [open, evidenceId, refresh]);
  return (
    <>
      <PurchaseModal
        open={open && (!access || !!error)}
        title='View Image'
        onClose={onClose}
        footer={
          <button
            type='button'
            className='rounded-md bg-blue-600 px-4 py-[10px] text-white'
            onClick={onClose}
          >
            Close
          </button>
        }
      >
        {loading && <p role='status'>Loading payment evidence…</p>}
        <PurchaseError error={error} />
        {error && (
          <button
            type='button'
            className='text-blue-600 underline'
            onClick={() => setRefresh(value => value + 1)}
          >
            Reload image
          </button>
        )}
      </PurchaseModal>
      <EvidenceLightbox open={open && !!access && !error} onClose={onClose}>
        {access && !error && (
          <img
            src={access.url}
            alt={access.fileName}
            className='h-full w-full object-contain'
            referrerPolicy='no-referrer'
            onError={() =>
              setError(
                new Error(
                  'The payment evidence could not be loaded. Reload the image to request a new link.'
                )
              )
            }
          />
        )}
      </EvidenceLightbox>
    </>
  );
};
export default EvidenceViewer;
